import React from 'react'
import { shallow } from 'enzyme'
import {Checklist}  from '../../features/ChecklistItems/Checklist'
import NotesUtil from '../../helpers/NotesUtil'

describe('Checklist', () => {
  let wrapper, props, result, instance
  const noop = () => {}
  beforeEach(() => {
    props = {
      checked:  false,
      description: "Sample description <a href='www.google.com'>Testing</a>",
      markNotificationRead: () => {
        result = 'markNotificationRead'
      },
      markAsRead: noop,
    }

    wrapper = shallow(<Checklist {...props} />)
    instance = wrapper.instance()
  })

  describe('#anchorLinkListener', () => {
    it('should run function if a present', () => {
      const gotoTab = spyOn(NotesUtil, 'gotoTab')
       instance.anchorLinkListener({ target: { tagName: 'A' } })
      expect(gotoTab).toHaveBeenCalled()
    })
    it('should not run function if a not present', () => {
      const gotoTab = spyOn(NotesUtil, 'gotoTab')
       instance.anchorLinkListener({ target: { tagName: 'Li' } })
      expect(gotoTab).not.toHaveBeenCalled()
    })
  })

  describe('#markAsRead', () => {
    it('should call function', () => {
      const markAsRead = spyOn(instance, 'markAsRead')
      let checkbox = wrapper.find('#checkbox').at(0);
      expect(checkbox.props().defaultChecked).toBeFalsy();
      instance.markAsRead();
      expect(markAsRead).toHaveBeenCalled()
    })
  })
})
